import { apiClient } from './client'
import type { PageResponse } from '@/types/common'
import type {
  GeneratedTest,
  TestGenerationRequest,
  TestResult,
  TestResultSummary,
  TestSubmitRequest,
} from '@/types/test'

export const testsApi = {
  generateTest: (request: TestGenerationRequest) =>
    apiClient.post<GeneratedTest>('/tests/generate', request).then((r) => r.data),

  submitTest: (testId: string, request: TestSubmitRequest) =>
    apiClient.post<TestResult>(`/tests/${testId}/submit`, request).then((r) => r.data),

  getHistory: (page = 0, size = 10) =>
    apiClient.get<PageResponse<TestResultSummary>>('/tests/history', { params: { page, size } }).then((r) => r.data),

  getTest: (testId: string) =>
    apiClient.get<GeneratedTest>(`/tests/${testId}`).then((r) => r.data),
}
